import { render, staticRenderFns } from "./CourseGroupEditPage.vue?vue&type=template&id=83b257a6"
import script from "./CourseGroupEditPage.vue?vue&type=script&lang=js"
export * from "./CourseGroupEditPage.vue?vue&type=script&lang=js"
import style0 from "./CourseGroupEditPage.vue?vue&type=style&index=0&id=83b257a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports